import React, { useEffect, useState } from 'react';
import InfoIcon from '@mui/icons-material/Info';
import HistoryIcon from '@mui/icons-material/History';
import { Link, useNavigate, useParams } from 'react-router-dom';
import S from './ListDam.module.css'
import D from '../images/history.svg'

import {  useSelector } from 'react-redux';


import apiService from '../api/ApiService';
import { ArrowBack, ArrowForward, DateRange, DateRangeRounded, Key, KeyboardBackspace, Report, SplitscreenOutlined } from '@mui/icons-material';
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';
import History from '../Components/HOCcattles/History';
import useHistoryCycle from '../Components/CustomHooks/useHistoryCycle';
const moment=require('moment-jalaali')
export default function ListCattleHistoryCycle() {
  const navigate=useNavigate()

  return (
    <div className={S.AllAnimalssLICon}>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',width:'100%'}}>
      <div className={S.AllAnimalssTitleLICon}>
        <img className={S.AllAnimalssIconimgLITit} style={{width:'70px',height:'70px'}} src={D}/>
        <h2> تاریخچه چرخه دام</h2>
        </div>
        <div onClick={()=>{navigate(-1)}}  className='backButton' >
          <KeyboardBackspace fontSize='large'/>
        </div>
         
           
      </div>
      <hr/>
       <History flag={''}/>
        
    </div>
  );
}